import React, { FC } from "react";
import { LogicalDAG } from "../../../hamilton/dagTypes";
import { SearchCatalogue } from "./SearchTable";

export const Catalogue: FC<{ dag: LogicalDAG }> = (props) => {
  return <SearchCatalogue dag={props.dag} />;
};
